import { render, staticRenderFns } from "./GlobalNavigation.vue?vue&type=template&id=96408298&scoped=true&"
import script from "./GlobalNavigation.vue?vue&type=script&lang=ts&"
export * from "./GlobalNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalNavigation.vue?vue&type=style&index=0&id=96408298&lang=scss&scoped=true&"
import style1 from "./GlobalNavigation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96408298",
  null
  
)

export default component.exports